// src/utils/sessionRevoked.js
// Il backend risponde 401 + header X-Session-Revoked quando la sessione non vale
// più (account cancellato, disattivato o sessioni revocate). Qui la sessione
// locale viene chiusa una volta sola, da qualunque chiamata fetch/axios arrivi.
import { AUTH_CHANGED_EVENT } from "../context/CartContext";
import { clearRememberedRedirect } from "./authRedirect";
import { clearBiometricLoginCredentials } from "./biometricLogin";

const HEADER = "X-Session-Revoked";
let handling = false;

export function handleSessionRevoked(reason) {
  if (handling || !localStorage.getItem("token")) return;
  handling = true;

  localStorage.removeItem("token");
  clearRememberedRedirect();
  // Account cancellato: le credenziali salvate per FaceID/impronta non
  // potranno più funzionare. Negli altri casi restano (es. riattivazione).
  if (reason === "deleted") {
    clearBiometricLoginCredentials().catch(() => {});
  }
  window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));

  // Niente markJustLoggedOut: non è un logout volontario.
  if (!window.location.pathname.startsWith("/login")) {
    window.location.assign("/login");
  } else {
    handling = false;
  }
}

export function installSessionRevokedFetch() {
  if (typeof window === "undefined" || window.fetch?.__sessionRevokedWrapped) return;
  const originalFetch = window.fetch.bind(window);
  const wrapped = async (...args) => {
    const response = await originalFetch(...args);
    const reason = response?.headers?.get?.(HEADER);
    if (response?.status === 401 && reason) handleSessionRevoked(reason);
    return response;
  };
  wrapped.__sessionRevokedWrapped = true;
  window.fetch = wrapped;
}

export function installSessionRevokedAxios(instance) {
  if (!instance || instance.__sessionRevokedInstalled) return;
  instance.__sessionRevokedInstalled = true;
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const res = error?.response;
      const reason = res?.headers?.["x-session-revoked"];
      if (res?.status === 401 && reason) handleSessionRevoked(reason);
      return Promise.reject(error);
    }
  );
}
